import { Box } from 'components/Box/Box';
import { Icon } from 'components/Icon/Icon';
import { Text } from 'components/Text/Text';
import { colors, fontWeights } from 'theme/theme';

export function GradfairNotificationContent() {
  return (
    <Box>
      <Text
        fontWeight={fontWeights.normal}
        fontSize="12px"
        $textTransform="uppercase"
        color={colors.lightContentGrey}
        marginBottom="5px"
      >
        <Box mr="6px" display="inline">
          <Icon name="graduation-cap" size={18} />
        </Box>
        {getText('Free event')}
      </Text>
      <Text fontWeight={fontWeights.semiBold}>
        {getText('Idealist is hosting a Grad Fair in NYC')}
      </Text>
      <Text fontWeight={fontWeights.normal} marginBottom="5px">
        {getText(
          'Discover top programs, network with admissions, and advance your social-impact career.',
        )}
      </Text>
      <Text fontWeight={fontWeights.semiBold} color={colors.brandBlue}>
        Learn more <Icon name="arrow-right" size={16} />
      </Text>
    </Box>
  );
}
